export default "__VITE_ASSET__DkfuF5cD__"